<template>
  <v-card>
    <v-card-title>
        <h3>History Update {{namaUser}}</h3>
    </v-card-title>
    <v-card-text>
        <v-data-table
          :headers="headers"
          :items="historyData"
          :search="search"
          hide-default-footer
        ></v-data-table>
    </v-card-text>
    <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="error"
          @click="onClose"
        >
          Back
        </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from '@/axios'
  export default {
    data () {
      return {
        search: '',
        headers: [
          { text: 'Alamat', value: 'ALAMAT_LENGKAP' },
          { text: 'Nomor Hp', value: 'NO_HP' },
          { text: 'Nomor Telp', value: 'NO_TELP' },
          { text: 'Last Update', value: 'LAST_UPDATE_DATE' },
        ],
        historyData: [],
        namaUser:''
      }
    },
    mounted() {
        this.initialize();
    },
    methods: {
      onClose(){
          this.$emit('onCloseDialog');
      },
      initialize(){
                axios({
                    method: 'post',
                    url: 'getDataNama',
                    data: {
                        id:this.idDatatable
                    },
                    headers: {
                      'Authorization': 'Bearer ' + this.$session.get('token'),
                    },
                }).then(response => {
                    //  Swal.fire({
                    //             title:'Peringatan',
                    //             icon :'success',
                    //             text:response.data.message
                    //         });
                    // //this.printProfile(response.data.id,this.formData.nama)

                    // this.onReset();
                    // this.$emit('onCloseDialog');
                    // console.log(JSON.stringify(response));
                    // this.users=response.data;
                    this.namaUser=response.data;
                }).catch(error=>{
                    console.log('Error Fetch Data '+error);
                    // var status = error.response.status
                });
                axios({
                    method: 'post',
                    url: 'get_data_history',
                    data: {
                        id:this.idDatatable
                    },
                    headers: {
                      'Authorization': 'Bearer ' + this.$session.get('token'),
                    },
                }).then(response => {
                    //  Swal.fire({
                    //             title:'Peringatan',
                    //             icon :'success',
                    //             text:response.data.message
                    //         });
                    // //this.printProfile(response.data.id,this.formData.nama)

                    // this.onReset();
                    // this.$emit('onCloseDialog');
                    // console.log(JSON.stringify(response));
                    // this.users=response.data;
                    this.historyData=response.data;
                }).catch(error=>{
                    console.log('Error Fetch Data '+error);
                    // var status = error.response.status
                });
      }
    },
    props: {
        idDatatable: String
    }
  }
</script>